import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit {

  hasSuccess = false;
  error = '';
  verifiedUserId = null;
  isVerifiedAnotherSession = false;

  constructor(private route: ActivatedRoute, private router: Router) { 
    let currentUser = JSON.parse(localStorage.getItem('pToken'));
    this.route.queryParams.subscribe(params => {
      this.hasSuccess = params['success'] == 1;
      this.error = params['error'];
      this.verifiedUserId = params['user'];
      this.isVerifiedAnotherSession = currentUser && currentUser.user && currentUser.user.id != this.verifiedUserId;
  });
  }

  ngOnInit() {
    if (this.hasSuccess && !this.isVerifiedAnotherSession) {
        setTimeout(()=> {
          this.router.navigateByUrl('/home');
        }, 5000);
  }
  }

}
